import { render, staticRenderFns } from "./monthly-export.vue?vue&type=template&id=23d8c4eb&scoped=true&"
import script from "./monthly-export.vue?vue&type=script&lang=js&"
export * from "./monthly-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8c4eb",
  null
  
)

export default component.exports